import { render, staticRenderFns } from "./UserBind.vue?vue&type=template&id=1f2b5617&scoped=true&"
import script from "./UserBind.vue?vue&type=script&lang=js&"
export * from "./UserBind.vue?vue&type=script&lang=js&"
import style0 from "./UserBind.vue?vue&type=style&index=0&id=1f2b5617&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b5617",
  null
  
)

export default component.exports